export default {"src":"/_next/static/media/3.290fcb20.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};